// v30 — Prehľadová štatistická dlaždica (podľa mockupu majiteľky).
// v33 — centrovaný redizajn: veľké centrované číslo, pod ním názov, pod ním opis;
// ikona (predtým malý farebný chip vľavo hore) je teraz VEĽKÁ a priesvitná v pozadí
// dlaždice — rovnaký vizuálny jazyk ako watermark ikona tieru na verejnom profile
// (pozri ProfileBody.jsx). Akcent príde z per-témovej palety (--stat-flame /
// --stat-growth / --stat-sun) a farbí ikonu na pozadí aj progres pruh dole.
// `badge` = voliteľný malý odznak v opačnom rohu (napr. „dnes ✓", keď je dnešná
// séria už predĺžená).
export function StatTile({ accent = "var(--brand-primary)", icon, value, label, sub, pct, onClick, style, className = "", title, chevron, hero = false, badge, ...rest }) {
  const Tag = onClick ? "button" : "div";
  if (hero) accent = "var(--hero-soft)";
  return (
    <Tag type={onClick ? "button" : undefined} onClick={onClick} title={title}
      className={`bz-stattile${onClick ? " bz-stattile--button" : ""}${chevron ? " bz-stattile--chev" : ""}${hero ? " bz-stattile--hero" : ""} ${className}`.trim()} style={style} {...rest}>
      {icon && <span className="bz-stattile__bgicon" style={{ color: accent }} aria-hidden="true">{icon}</span>}
      {badge && <span className="bz-stattile__badge">{badge}</span>}
      <span className="bz-stattile__num">{value}</span>
      <div className="bz-stattile__label">{label}</div>
      {sub != null && <div className="bz-stattile__sub">{sub}</div>}
      {pct != null && (
        <div className="bz-stattile__bar" aria-hidden="true">
          <div className="bz-stattile__fill" style={{ width: `${Math.max(0, Math.min(100, pct))}%`, background: accent }} />
        </div>
      )}
      {chevron && <span className="bz-stattile__chev" aria-hidden="true">{chevron}</span>}
    </Tag>
  );
}
